// @flow
import React from 'react';
import Box from "@mui/material/Box";
//import PermissionHOC from "../../modules/permission/components/permissionHOC/permissionHOC";
import CheckForm from "../requestsForm/requestsForm";
import RequestsForm from "../requestsForm/requestsForm";
import ProfileDetails from "../profile/profileDetails";

const Home = () => {
    return (
        <Box>
            {/*<PermissionHOC requiredPermissions={['access_CheckForm']}>*/}
            {/*<RequestsForm/>*/}
            <ProfileDetails/>
            {/* </PermissionHOC>*/}
        </Box>
    )
}

export default Home
